<template>
  <div class="">
    <section class="clients-area pt-100 pb-70">
      <div class="container">

        <div class="section-title">
          <h2 v-if="!dataLoading">{{ $t('app.our_services') }}</h2>
          <h2 v-if="dataLoading" class="webkit-animation col-4 offset-4 webkit-none-50"></h2>
        </div>

        <div v-if="dataLoading" class="col-12 row">
          <div class="item col-4" v-for="(item, idx) in 3" :key="idx">
            <div class="feature-item two webkit-animation webkit-none-150"></div>
          </div>
        </div>

        <carousel v-if="!dataLoading && services && services.length" :autoplay="true" :loop="true" :dots="false"
          :margin="20" :touchDrag="true" :items="5" :center="true"
          :responsive="{ 0: { items: 2 }, 767: { items: 2 }, 1000: { items: 5 } }" :nav="true"
          :navText="[`<i class='icofont-rounded-double-left'></i>`, `<i class='icofont-rounded-double-right'></i>`]">

          <div class="item" v-for="(item, idx) in services" :key="idx">
            <div class="feature-item two">
              <img v-if="item.image" :src="item.image" style="width:140px;height: 140px;border-radius: 50%">
              <h3>
                <a href="javascript:;">
                  {{ ($i18n.locale == 'en') ? item.en.title : item.ar.title }}
                </a>
              </h3>
            </div>
          </div>
        </carousel>

      </div>
    </section>

  </div>
</template>

<script>
import carousel from 'v-owl-carousel'

export default {
  name: 'HowApply',
  components: {
    carousel
  },
  data() {
    return {
      //
      services: [],
      refs: 'services',
      dataLoading: true,
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.dataLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID
        },
      }
      this.axios(options)
        .then(res => {
          this.dataLoading = false;
          this.services = res.data.data.rows;
        })
        .catch(() => {
          //
        })
        .finally(() => {
        });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
